// LinkedIn API Integration
import axios from "axios";
import applyInterceptor from "./utils/interceptors";
import { useDispatch } from "react-redux";

// Example: Creating the Axios instance for LinkedIn
const linkedInApi = () => {
  // const dispatch = useDispatch();

  const instance = axios.create({
    baseURL: "https://api.linkedin.com/v2",
  });

  return applyInterceptor(instance);
};

const linkedInClient = linkedInApi(); // Apply interceptors

export const getProfile = async (accessToken: string) => {
  const response = await linkedInClient.get('/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const getFirstDegreeConnectionsSize = async (accessToken: string) => {
  const response = await linkedInClient.get('/networkSizes/urn:li:person:YOUR_PROFILE_ID?edgeType=CompanyFollowedByMember', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};


export const getConnections = async (accessToken: string) => {
  const response = await linkedInClient.get('/connections?q=viewer&start=0&count=50', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const postShare = async (accessToken: string, shareContent: any) => {

  if(shareContent.image){
//Register the media

    const mediaResponse = await linkedInClient.post('/media', {
      "registerUploadRequest": {
        "recipes": [
          "urn:li:digitalmediaRecipe:feedshare-image"
        ],
        "owner": "urn:li:person:YOUR_PROFILE_ID",
        "serviceRelationships": [
          {
            "relationshipType": "OWNER",
            "identifier": "urn:li:userGeneratedContent"
          }
        ]
      }
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const mediaId = mediaResponse.data.id;

    //Upload the image
    const uploadUrl = mediaResponse.data.uploadMechanism["com.linkedin.digitalmedia.uploading.MediaUploadHttpRequest"].uploadUrl;
    const uploadResponse = await axios.put(uploadUrl, shareContent.image, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'image/jpeg',
      },
    });

    shareContent.media = {
      "media": mediaId
    };

    delete shareContent.image;

    


  }

  const response = await linkedInClient.post('/ugcPosts', shareContent, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};
export const getCompanyProfile = async (accessToken: string, companyId: string) => {
  const response = await linkedInClient.get(`/organizations/${companyId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const getJobPosts = async (accessToken: string, companyId: string) => {
  const response = await linkedInClient.get(`/jobs?companyId=${companyId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const sendMessage = async (accessToken: string, recipientId: string, message: any) => {
  const response = await linkedInClient.post(`/messaging/conversations`, {
    recipients: [recipientId],
    message,
  }, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};
export const getUserEmail = async (accessToken: string) => {
  const response = await linkedInClient.get('/emailAddress?q=members&projection=(elements*(handle~))', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const searchUsers = async (accessToken: string, keywords: string) => {
  const response = await linkedInClient.get(`/search?q=people&keywords=${encodeURIComponent(keywords)}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

export const searchCompanies = async (accessToken: string, keywords: string) => {
  const response = await linkedInClient.get(`/search?q=companies&keywords=${encodeURIComponent(keywords)}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};